import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {useHistory} from "react-router";

export default function ReactRedirect({to, external}) {
  const history = useHistory();

  useEffect(() => {
    if (external) {
      window.location = to;
    } else {
      history.push(to);
    }
  }, [history, to, external]);

  return null;
}

ReactRedirect.propTypes = {
  to: PropTypes.string.isRequired,
  external: PropTypes.bool,
};
